// eslint-disable-next-line import/no-anonymous-default-export
export default function (param) {
    return new URL(window.location.href).searchParams.get(param);
}